$(document).ready(function(){

    // Header.init(600);
    //Cookiebar.init();

    Menu.init();
    // SearchAutocomplete.init();
    // Banner.init();
    Picture.init();
    // Homepage.init();
    // Popup.init();
    YouTubeVideo.resize();
    // Expander.init();
    // Ol.init();
    // Table.init();

    // Footer.pinBottom();
    // Articles.init();
    // Datepicker.init();
    // Galeria.Gallery.init();
    $('body').removeClass('hidden');
}); 

var resizeId;
$(window).resize(function() {
    clearTimeout(resizeId);
    resizeId = setTimeout(doneResizing, 300);
});
 
function doneResizing(){
    Menu.resize();
    // Footer.pinBottom();
    // Titulka.resize();
    // Banner.resize();
    // Expander.init();
    Header.resize();
    YouTubeVideo.resize();

    // BoxRotator.resize();
}

$(window).load(function(){
});


Iframe = {
    init: function(collection) {
        var iframe = $('iframe', collection || $('body'));

        if(!iframe.length) return;

        iframe.each(function(index, el) {
            $(this).parent().attr('load', '');
            $(this).load(function() {
                $(this).parent().removeAttr('load');
            });
        });
    }
}
